




































































export default

	props:
		traceData: Object

	data: ->
		current: 'profile'
		product: []
		sections: [
			{
				label: 'Profile'
				id: '#profile'
			},
			{
				label: 'Origins'
				id: '#origins'
			},
			{
				label: 'Healthy Phenols'
				id: '#phenols'
			},
			{
				label: 'Certification & Testing'
				id: '#certification'
			},
			{
				label: 'How it\'s Made'
				id: '#how-its-made'
			}

		]

	mounted: ->
		@$wait 100, =>
			@setNav '#profile'

	computed:
		newsletterData: -> @$store.state.globals.newsletter

		computedProduct: -> if @product.length > 0 then return @product

		newsletterBlock: ->
			body: [
				"<h2 class='style-h2'>#{@newsletterData.title}</h2>" if @newsletterData.title
				"<p>#{@newsletterData.description}</p>" if @newsletterData.description
			].join ' '

	methods:

		reset: -> @$emit('reset')

		setNav: (item) -> @current = item

		scrollIntoView: (id) ->
			@$refs[id].scrollIntoView
				behavior: 'smooth'

		updateProduct: (product) ->
			if product? then @product = product

